'use strict';exports.__esModule = true;exports.constructStaffLink = exports.constructCompanyLink = undefined;var _appendLocale = require('./appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var constructCompanyLink = exports.constructCompanyLink = function constructCompanyLink(locale, companyId) {return (
    (0, _appendLocale2.default)(locale, '/company/' + companyId));};

var constructStaffLink = exports.constructStaffLink = function constructStaffLink(locale, staffId) {return (0, _appendLocale2.default)(locale, '/staff/' + staffId);};


//////////////////
// WEBPACK FOOTER
// ./src/helpers/constructLink.js
// module id = 282
// module chunks = 0